import './bootstrap'
import './util.js'

if (window.history && window.history.pushState) {
    window.history.pushState('forward', null, '')
    $(window).on('popstate', function () {
        window.uncheckedMenu()
        window.hideMenuMobile()
    })
}

let elObserve = ''
const footer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            $('.help').addClass('hide')
        } else {
            $('.help').removeClass('hide')
        }
    });
}, {
    root: null,
    rootMargin: '0px',
    threshold: 0
});

if (!!updateMenu(elObserve)) {
    footer.observe(updateMenu(elObserve));
}

// $(window).on('resize', function () {
//     updateMenu()
//     if (viewport().width >= 1230) {
//         uncheckedMenu()
//         hideMenuMobile()
//     }
// })

//calc width window
window.viewport = function () {
    var e = window,
        a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return {
        width: e[a + 'Width'],
        height: e[a + 'Height']
    };
}

window.resizer = function () {
    updateMenu()
    if (viewport().width >= 1230) {
        uncheckedMenu()
        hideMenuMobile()
    }
}

$(window).resize(resizer);

$(document).on('click', '#pagination a', function(event) {
    event.preventDefault()

    let url = $(this).attr('href')
    window.history.pushState({}, null, url);

    $.ajax({
        type: 'GET',
        url: url,
        success:function(data) {
            $('#list-ajax').html(data)
            $('html, body').animate({
                scrollTop: $("#list-ajax").offset().top - 250
            }, 1000)
        }
    })

    return false
})

$(document).on('change', '#sort', function() {
    let order = $(this).val(),
        url = window.location.href.split('?')[0]
        url += '?page=1'

    $.ajax({
        url: url,
        dataType: 'html',
        type: "GET",
        data: {
            order: order,
        },
    })
    .done(function(response) {
        $('#list-ajax').html(response);
        $('html, body').animate({
            scrollTop: $("#list-ajax").parent().parent().offset().top
        }, 1000)

        var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname +'?page=1'
        window.history.pushState({ path: refresh }, '', refresh)
    })
    .fail((xhr, textStatus, errorThrown) => console.log(errorThrown))
})

$(document).ready(function () {
    $('#menuToggle').on('click', function () {
        let isChecked = $(this).is(':checked')

        if (isChecked) {
            $('.menuMob').addClass('active')
            $('.menu').addClass('active')
        } else {
            hideMenuMobile()
        }
    });

    //fix keyboard android
    //nav search exception on resize
    $('.searchbox').on('click', function () {
        $(window).off("resize", resizer);
    });

    $("#langcheck").on('click', function() {
        var currentLanguange = readCookie('googtrans');
        if (currentLanguange == '/id/id') {
            var select = document.querySelector('select.goog-te-combo');
            select.dispatchEvent(new Event('change'));

            select.value = 'en';
            select.dispatchEvent(new Event('change'));
        }else{
            if ($(this).val() == 'id') {
                var theLang = 'id';
            } else {
                var theLang = 'en';
            }
            if(theLang == 'en'){
                var select = document.querySelector('select.goog-te-combo');
                select.value = theLang;
                select.dispatchEvent(new Event('change'));
            }else{
                $('#\\:1\\.container').contents().find('#\\:1\\.restore').click();
            }
        }
    });

    var currentLanguange = readCookie('googtrans');
    if (currentLanguange == '/id/id') {
        $('#langcheck').val('id');
    } else if(currentLanguange == '/id/en' || currentLanguange == '/en/en') {
        $('#langcheck').val('eng');
    }else{
        $('#langcheck').val('id');
    }
});

const initDom = function () {
    const checkLanguage = function () {
        var currentLanguange = readCookie('lang');
        if (currentLanguange == 'id'){
            // $('#langcheck').setAttribute('value', 'id');
        }else{
            // $('#langcheck').setAttribute('value', 'eng');
        }
    }

    const menu = () => {
        window.uncheckedMenu()
        window.hideMenuMobile()
        window.updateMenu()
    }

    const buttonPassword = () => {
        $("#btnpass").click(function () {
            let input = $($(this).attr("toggle"));
            if (input.attr("type") == "password") {
                input.attr("type", "text");
                $(this).addClass("show")
            } else {
                $(this).removeClass("show")
                input.attr("type", "password");
            }
        })
    }

    const customSelect = () => {
        $('select').not('.select2').each(function () {
            if(this.id) window.loadCustomSelect(this.id)
        })
    }

    return {
        init: function() {
            menu()
            buttonPassword()
            // removePic()
            customSelect()
            checkLanguage()
        }
    }
}()

const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}

window.addEventListener("resize", appHeight)

$(function() {
    initDom.init()
    appHeight()
});

window.readCookie = function(name) {
    var c = document.cookie.split('; '),
        cookies = {},
        i, C;

    for (i = c.length - 1; i >= 0; i--) {
        C = c[i].split('=');
        cookies[C[0]] = C[1];
    }

    return cookies[name];
}

window.googleTranslateElementInit = function() {
    new google.translate.TranslateElement({
        pageLanguage: 'id',
        autoDisplay: false,
        // includedLanguages: 'en,id,fr',
        // layout: google.translate.TranslateElement.FloatPosition.TOP_LEFT,
    }, 'google_translate_element');
}


const target = document.querySelector('#headerUser')
let dropmenu = document.querySelector('#headerDashboard')
let dropmenubtn = document.querySelector('#headerUser')

if(dropmenu != null && dropmenubtn != null){
    document.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(target)

        if (!withinBoundaries) {
            dropmenubtn.classList.remove("active");
        }
    })
}
